// Template Generated by DataExtraction.py at 1716507313

import SKYC2English from "../../Forms/SKYC/SKYC-2English.png";
import SKYC2EnglishLabels from "../../Labels/SKYC/SKYC-2English.json";
import SKYC2French from "../../Forms/SKYC/SKYC-2French.png";
import SKYC2FrenchLabels from "../../Labels/SKYC/SKYC-2French.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYC2FrenchLabels : SKYC2EnglishLabels;
    const formImage = isFrench ? SKYC2French : SKYC2English;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    function drawLongText(value, label) {
        drawTextOnLabel(doc, value, label, labels, null, false, true);
    }


    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const now = moment().format("yyyy-MM-DD");
    const kyc = data.knowYourClient;
    const common = data.common;

    // Drawing the form
    drawText(now, "drDate");
    drawLongText(kyc.notes, "notes");
    drawText(now, "s1Date");
    if (common.subscriber2Include) {
        drawText(now, "s2Date");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? SKYC2FrenchLabels : SKYC2EnglishLabels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    const subscriber2Include = state.common.subscriber2Include

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2Signature", labels))],
        });
    }


    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignature", labels))],
    });


    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1Signature", labels))],
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
